import styled from 'styled-components';
import colors from 'constants/colors';

export const Head = styled.div`
  position: relative;
  font-size: 22px;
  font-weight: 600;
  color: ${colors.green};
  margin-bottom: 24px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  .text {
    color: ${colors.white};
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 16px 0; 
  }
`;

export const Footer = styled.div`
  font-weight: 300;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  padding-top: 24px;
`;
